import {FC} from 'react';
import {observer} from 'mobx-react-lite';
import {useLingui} from '@lingui/react';

import {compute, getTranslationString} from '../../util/size';
import {formatNumber} from '../../util/format';
import SettingStore from '../../stores/SettingStore';
import TransferDataStore from '../../stores/TransferDataStore';

const WindowTitle: FC = observer(() => {
  const {UIPageTitleSpeedEnabled: enabled} = SettingStore.floodSettings;
  const {transferSummary: summary} = TransferDataStore;
  const {i18n} = useLingui();

  let title = 'Flood';

  if (enabled && summary != null && Object.keys(summary).length > 0) {
    const down = compute(summary.downRate);
    const up = compute(summary.upRate);

    const formattedDownSpeed = formatNumber(i18n.locale, down.value);
    const formattedUpSpeed = formatNumber(i18n.locale, up.value);

    const translatedDownUnit = i18n._('unit.speed', {
      baseUnit: i18n._(getTranslationString(down.unit)),
    });
    const translatedUpUnit = i18n._('unit.speed', {
      baseUnit: i18n._(getTranslationString(up.unit)),
    });

    title = `↓ ${formattedDownSpeed} ${translatedDownUnit} ↑ ${formattedUpSpeed} ${translatedUpUnit} - Flood`;
  }

  document.title = title;

  return null;
});

export default WindowTitle;
